import cn from "clsx";
import { Col, Container, Row } from "@crehana/ui";
import { AcademyCardSkeleton } from "../../components/Cards/AcademyCard";
import { useAcademiesTranslation } from "./hooks/useAcademiesTranslation";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AcademiesSkeleton = function AcademiesSkeleton(_ref) {
  var _AcademyCardSkeleton;
  var className = _ref.className,
    isFullLayout = _ref.isFullLayout,
    containerProps = _ref.containerProps,
    isDark = _ref.isDark;
  var _useAcademiesTranslat = useAcademiesTranslation(),
    t = _useAcademiesTranslat.t;
  var renderAcademyListSkeleton = function renderAcademyListSkeleton() {
    return /*#__PURE__*/_jsx(Row, {
      className: !isFullLayout ? className : '',
      nowrap: true,
      children: Array.from({
        length: 4
      }).map(function (_, i) {
        return /*#__PURE__*/_jsx(Col, {
          xs: 12,
          sm: 6,
          md: 4,
          className: cn({
            'hidden sm:block': i === 1,
            'hidden md:block': i === 2
          }),
          children: _AcademyCardSkeleton || (_AcademyCardSkeleton = /*#__PURE__*/_jsx(AcademyCardSkeleton, {
            isDark: isDark
          }))
        }, "academy-skeleton-".concat(i * 1));
      })
    });
  };
  if (isFullLayout) {
    return /*#__PURE__*/_jsx("div", {
      className: "w-full flex flex-col p-20",
      children: /*#__PURE__*/_jsxs(Container, {
        full: !!(containerProps !== null && containerProps !== void 0 && containerProps.fullWidth),
        type: containerProps === null || containerProps === void 0 ? void 0 : containerProps.type,
        children: [/*#__PURE__*/_jsx("h4", {
          className: "font-h4 mb-20",
          children: t('ACADEMIES_TITLE')
        }), renderAcademyListSkeleton()]
      })
    });
  }
  return renderAcademyListSkeleton();
};
export default AcademiesSkeleton;